/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import DashboardListingDisplayCard from "components/DashboardListingsDisplayCard";
import { Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { FirebaseContext } from "common";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { STYLES } from "config";
import {
  Row,
  Col,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Container,
  FormText,
  Input,
  ModalFooter,
} from "reactstrap";

import CustomDropDownPicker from "../../components/CustomDropDownPicker";
import CreateListingsDashboardModal from "components/CreateListingDashboardModal";
import CreateEnquiryDashboardModal from "components/CreateEnquiryDashboardModal";
import CreateAreaDashboardModal from "components/CreateAreaDashboardModal";

const AreaInfo = () => {
  const [currentBranch, setCurrentBranch] = useState({});

  const usersdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const areaData = useSelector((state) => state.areaData);

  const { api } = useContext(FirebaseContext);
  const {
    updateAreaBroker,
    removeBrokerFromArea,
  } = api;

  const navigate = useNavigate();
  const location = useLocation();
  let branch = auth.info.profile.adminHomeOffice
    ? auth.info.profile.adminHomeOffice
    : auth.info.profile.brokerHomeOffice;
  const dispatch = useDispatch();

  const brokers = useSelector((state) => state.brokers.users);
  const listings = useSelector((state) => state.ListingData.listingsByBranch);
  const branchManagementReducer = useSelector((state) => state.branchData);
  const activeListingsByBranch = useSelector(
    (state) => state.ListingData.activeListingsByBranch
  );
  const inactiveListingsByBranch = useSelector(
    (state) => state.ListingData.inactiveListingsByBranch
  );
  const enquiryManagementReducer = useSelector((state) => state.enquirydata);
  const branchEnquiries = useSelector(
    (state) => state.enquirydata.branchEnquirries
  );
  const activeBranchEnquiries = useSelector(
    (state) => state.enquirydata.activeBranchEnquiries
  );
  const inactiveBranchEnquiries = useSelector(
    (state) => state.enquirydata.inactiveBranchEnquiries
  );

  const area = location.state;
  const [brokerList, setBrokerList] = useState([]);
  const [allBrokersList, setAllBrokersList] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [state, setState] = useState({
    areaId: area.areaId,
    areaName: area.areaName,
    Location: area.Location,
    shareBrokers: [],
  });

  const EditArea = () => {
    //Inriching Enquiry Data before sending it to the action
    // !DO NOT CHANGE WITHOUT PERMISSION FROM GAYNOR OR STEVEN!!!
    // ?last updated 25/04/2025
    let areaData = {
      areaId: state.areaId,
      //selectedBranch: state.selectedBranch,
      areaName: state.areaName,
      shareBrokers: state.shareBrokers,
    };
    console.log("areaData", areaData);

    handleSubmit(areaData);
  }

  const removeBroker = (broker) => {
    let brokerAreas = broker?.Areas;
    let allUsersArray = usersdata.users;

    if (Object.values(brokerAreas || {}).includes(area.areaName)) {
      const userConfirmed = window.confirm(
        `Are you sure you want to remove the broker from "${area.areaName}"?`
      );

      if (userConfirmed) {
        try {
          console.log("broker data:", broker);

          dispatch(removeBrokerFromArea(broker, area));
          alert("Broker removed Successfully");
        } catch (error) {
          console.error("Failed to remove broker:", error);
          alert("Something went wrong while removing the broker.");
        }
      }
    } else {
      console.log("Broker removal cancelled by user.");
    }

  }

  const handleSubmit = async (areaData) => {
    if (
      state.areaId &&
      state.shareBrokers.length > 0
    ) {
      try {
        await dispatch(updateAreaBroker(areaData)); // assuming addArea is a thunk
        alert("Broker added Successfully");
      } catch (error) {
        console.error("Failed to add broker:", error);
        alert("Something went wrong while adding the broker.");
      }
    }else{
      alert(`No area ID or no sharebrokers provided!`);
    }
  };

  useEffect(() => {
    let arr = [];
    let arr2 = [];

    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers

        arr.push({
          value: element.id, // The broker ID (or name if preferred)
          label: `${element.firstName} ${element.lastName}`, // Broker name
        });

      }
      setAllBrokersList(arr.sort((a, b) => a.label.localeCompare(b.label)));
      console.log("All Brokers List:", arr); // Log broker list to verify population
    }
  }, [brokers]);

  useEffect(() => { //checks which brokers have this area in their broker Object
    let arr = [];
    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        //brokers areas
        const brokerAreas = element?.Areas;

        if (brokerAreas) {  //Checking if broker has the matching location or the areaId of the area object
          const hasValue = 
          //Object.values(brokerAreas || {}).includes(area.Location) ||
          Object.keys(brokerAreas || {}).includes(area?.areaId);

          if (hasValue) {
            arr.push(element);
          }

        }
      }

      setBrokerList(
        arr.sort((a, b) => a?.username?.localeCompare(b?.username))
      );
    }
  }, [brokers]);

  const saveData = (location, data) => {
    setState({
      ...state,
      [location]: data,
    });
  };

  return usersdata.loading ? (
    <CircularLoading />
  ) : (
    <div>
      <Grid container direction="row" spacing={2}>
        <Grid item xs>
          <Card
            style={{
              backgroundColor: STYLES.PRIMARY_APP_CLR,
              width: "100%",
              height: "20%",
            }}
          >
            <CardHeader>
              <CardTitle tag="h4" style={{ color: "white" }}>
                Area Information
              </CardTitle>
            </CardHeader>
            <CardBody>
              <Container>
                <>
                  <Row>
                    <Col md="12">
                      <Card
                        style={{
                          minWidth: "275px",
                          border: "none",
                          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <CardHeader
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderBottom: STYLES.PRIMARY_APP_CLR,
                          }}
                        >
                          <CardTitle
                            tag="h4"
                            style={{ color: STYLES.TERTIARY_APP_CLR, fontWeight: "bold" }}
                          >
                            {currentBranch.BranchName} Area Details
                          </CardTitle>
                        </CardHeader>
                        <CardBody style={{ padding: "20px" }}>
                          <Row>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Area Name:</strong>{" "}
                                {area.areaName ? area.areaName : ""}
                              </p>
                            </Col>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Branch:</strong>{" "}
                                {area.selectedBranchName ? area.selectedBranchName : ""}
                              </p>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </>

              </Container>
            </CardBody>
          </Card>
        </Grid>
      </Grid>

      <Row>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer spacing={1}>

            <GridItem xs={6}>
              {/*Broker List Card */}
              <Card
                style={{
                  backgroundColor: "#399ddb",
                  width: "95%",
                  height: "100%",
                  justifyContent: "center"
                }}
              >
                <CardHeader>
                  <CardTitle tag="h4" style={{ color: "white" }}>
                    ADD BROKERS
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <GridContainer spacing={1}>
                      <GridItem xs={12}>
                        <FormText color="white" tag="span">
                          Brokers:
                        </FormText>

                        {allBrokersList && allBrokersList.length > 0 ? (
                          <CustomDropDownPicker
                            options={allBrokersList}
                            isMulti={true}
                            onChange={(selectedBrokers) => {
                              saveData("shareBrokers", selectedBrokers)
                            }}
                          />
                        ) : (
                          <FormText color="grey">No brokers available</FormText> // Fallback if no brokers
                        )}
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </CardBody>
                <ModalFooter>
                  <Button
                    style={{
                      backgroundColor: "GRAY",
                      height: 45,
                      marginRight: 10,
                      color: "white",
                    }}
                    onClick={
                      EditArea
                    }
                  >Add Brokers</Button>
                </ModalFooter>
              </Card>
            </GridItem>

            <GridItem xs={6}>
              {/*Broker List Card */}
              <DashboardListingDisplayCard title="BROKERS">
                <Row mb="12">
                  <Col md="12">
                    <span style={{ fontSize: 18, margin: 5 }}>
                      Total Branch Brokers:
                    </span>{" "}
                    {brokerList.length}
                  </Col>
                  <hr />
                  {brokerList.map((broker) => {
                    return (
                      <>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                            margin: 5,
                          }}
                        >
                          <div>
                            <Button
                              color="primary"
                              onClick={() => {
                                if (
                                  auth.info.profile.adminHomeOffice === branch
                                ) {
                                  navigate("/BrokerProfile", {
                                    state: broker,
                                  });
                                } else {
                                  alert(
                                    "You do not have permission to view this content"
                                  );
                                }
                              }}
                            >
                              Broker Profile
                            </Button>
                          </div>

                          <div>
                            {" "}
                            <span style={{ fontSize: 18, color: "black" }}>
                              {" "}
                              {`${broker.firstName} ${broker.lastName}`}{" "}
                            </span>
                          </div>

                          <div>
                            <Button
                              color="primary"
                              onClick={() => {
                                if (
                                  auth.info.profile.adminHomeOffice === branch
                                ) {
                                  removeBroker(broker);
                                } else {
                                  alert(
                                    "You do not have permission to perform this action"
                                  );
                                }
                              }}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                        <hr />
                      </>
                    );
                  })}

                  {/* Add more statistics as needed */}
                </Row>
              </DashboardListingDisplayCard>
            </GridItem>

          </GridContainer>
        </GridItem>
      </Row>
    </div>
  );
};


export default AreaInfo
